import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	saleStartBeforeDate: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetSaleStartBeforeDate: (input: number | undefined) => void;
};

export const QuestionPlanSaleStartBeforeDate = ({
	saleStartBeforeDate,
	onSetSaleStartBeforeDate: _onSetSaleStartBeforeDate,
}: Props) => {
	const onSetSaleStartBeforeDate = (e: number | undefined) => {
		_onSetSaleStartBeforeDate(e);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"予約の開始日時"}
			isEdited={saleStartBeforeDate?.isEdited}
			hasError={Boolean(saleStartBeforeDate?.error)}
			inputChildren={
				<QuestionSectionWrapper>
					<p className="text-sm">チェックイン日の</p>
					<InputNumberField
						value={saleStartBeforeDate?.value ?? undefined}
						handleInput={onSetSaleStartBeforeDate}
						errorMessage={saleStartBeforeDate?.error}
						hiddenSpinButton={false}
					/>
					<p className="text-sm">日前から予約可能</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionPlanSaleStartBeforeDate.displayName = "QuestionPlanSaleStartBeforeDate";
